import './IconTranslate.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconTranslate = _ref => {
  let {
    width = 38,
    height = 38,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 38 38",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16739",
    "data-name": "Group 16739",
    transform: "translate(-379.359 -1272.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M1.044,0H36.956C37.533,0,38,1.467,38,3.276V34.724C38,36.533,37.533,38,36.956,38H1.044C.467,38,0,36.533,0,34.724V3.276C0,1.467.467,0,1.044,0Z",
    transform: "translate(379.359 1272.359)",
    fill: "#035e88"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15761",
    "data-name": "Group 15761",
    transform: "translate(1 5.359)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\u0639",
    transform: "translate(386 1284)",
    fill: "#fff",
    fontSize: "15",
    fontFamily: "Dubai-Medium, Dubai",
    fontWeight: "500"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0",
    y: "0"
  }, "\u0639")), /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(400 1297.641)",
    fill: "#fff",
    fontSize: "14",
    fontFamily: "Dubai-Medium, Dubai",
    fontWeight: "500"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0",
    y: "0"
  }, "A")), /*#__PURE__*/React.createElement("path", {
    id: "Path_6996",
    "data-name": "Path 6996",
    d: "M8.584,1.888V.572a.573.573,0,0,1,1.146,0V3.436a.57.57,0,0,1-.573.572H6.295a.573.573,0,1,1,0-1.146H7.955A4,4,0,0,0,1.146,5.718.573.573,0,1,1,0,5.718,5.152,5.152,0,0,1,8.584,1.888Z",
    transform: "translate(403.794 1274.505) rotate(60)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    d: "M8.584,1.888V.572a.573.573,0,0,1,1.146,0V3.436a.57.57,0,0,1-.573.572H6.295a.573.573,0,0,1,0-1.146H7.955A4,4,0,0,0,1.146,5.718.573.573,0,1,1,0,5.718,5.152,5.152,0,0,1,8.584,1.888Z",
    transform: "translate(391.206 1299.929) rotate(-120)",
    fill: "#fff"
  }))));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1l0wzut"
});
export default IconTranslate;